import {Component, Input, OnInit} from '@angular/core';
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../../../core/shared/helper/widget-function-call-back-create";

@Component({
    selector: 'bm-dunning-type-level-trigger-logic-field',
    templateUrl: './bm-dunning-type-level-trigger-logic-field.component.html',
    standalone: false
})
export class BmDunningTypeLevelTriggerLogicFieldComponent implements OnInit {

    @Input() dunningTypeTriggerId: number;
    dunningTypeLevelTriggerLogicFieldData: WidgetData;

    ngOnInit() {
        this.refreshDataWidget();
    }

    refreshDataWidget() {

        const filterCriteria = FilterCriteria.create('q.dunningProcessTypeTriggerId', FilterCriteria.cOperatorEqual, this.dunningTypeTriggerId);
        // this.dunningTypeLevelTriggerLogicFieldData = WidgetFactory.createWidgetTableEntity(
        //     'bm.dunning.object.shared.dunning.type.level.trigger.logic.field.table',
        //     'Dunning Type Level Trigger Logic Field',
        //     'bm.DunningTypeLevelTriggerLogicField',
        //     'Keine Einträge gefunden.',
        //     ObjectRequestList.createBasic(true, [filterCriteria], [])
        // );

        this.dunningTypeLevelTriggerLogicFieldData = WidgetFactory.createWidgetTableEntityQl('bm.dunning.object.shared.dunning.type.level.trigger.logic.field.table', 'Dunning Type Level Trigger Logic Field', 'bm.DunningTypeLevelTriggerLogicField', 'Keine Einträge gefunden.', [filterCriteria]);

        const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'dunningProcessTypeTriggerDtoId', fieldValue: this.dunningTypeTriggerId}]

        this.dunningTypeLevelTriggerLogicFieldData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);
    }
}
